import {  useEffect, useState, useMemo } from "react";
import {  Link } from "react-router-dom";
import { useGetUserOrderQuery, useUpdateOrderMutation } from "context/order/orderApiSlice"; 

import { formatDistanceToNow, parseISO } from 'date-fns';
import frLocale from 'date-fns/locale/fr';

import { useMaterialUIController,  setOpenConfigurator } from "context";
// Material Dashboard 2 React components

import Icon from '@mui/material/Icon';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';

import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDAvatar from "dashboard/components/MDAvatar";
import MDBadge from "dashboard/components/MDBadge";
import MDButton from "dashboard/components/MDButton";

import { OptionsSelect } from "dashboard/examples/Forms/CostumFormFields/SelectMutipple";
import IosSwitch from "dashboard/examples/Forms/CostumFormFields/IosSwitch";
import Stack from "@mui/material/Stack";

// Images
import useAlert from "hooks/useAlert";
import useSearch from "hooks/useSearch";


export default function Data({ decodeURL }) {

  const [controller, dispatch] = useMaterialUIController();
  const { openConfigurator } = controller;
  const [noMoreResults, setNoMoreResults] = useState(false);
  const [updateOrder] = useUpdateOrderMutation();
  const {showAlerts} = useAlert();
  const { searchTerm, filterSearch } = useSearch(); // filterSearch

  let ordersRows = [];
  let pageCount = 0;
  let orderList=[];
  let totalResult = 0;
   const ordersQuery = useMemo(
    () => ({
      page: searchTerm.page,
      filters: JSON.stringify({name : searchTerm.text, decodeURL}),
      ordersPerpage: 12,
     }),
    [searchTerm,  decodeURL]
  );

  const {
    data: orders = [],
    isLoading,
    isSuccess,
    isFetching,
    isError,
    error,
    
  } = useGetUserOrderQuery(ordersQuery, {
      // pollingInterval: 60000,
      refetchOnMountOrArgChange: true,
      skip: noMoreResults
  });

  const getOrders = ordersDetails => {
    filterSearch(ordersDetails)
  }
  
  if (isSuccess) {
    const {orders : ordersLoaded , total_results, ordersPerpage } = orders;
    orderList = ordersLoaded;
    pageCount = Number(Math.ceil(total_results / ordersPerpage ));
    totalResult = total_results
  }

  useEffect(() => {
    if(!orders?.length && ordersQuery?.page > 1 ) {
      setNoMoreResults(true);
    }

    /* eslint-disable */
    isError ? showAlerts({
      title : "Dashboard Alert",
      type  : "toast",
      msg :  error.data?.error || error.message,
      color :"error"
    }) : null
  }, [isError]);
  
  const handlePaid =  (id, paid) =>{ 
    paid === true && showAlerts({code:"info", icon:"info", title : "Mise à jour de la commande",msg : "Veuillez patienter... pendant la génération de la facture", type : "taost"});
    updateOrder({ id, update: {isPaid:Number(paid)}})
  };

  const handleAccepted =  (id, active) => updateOrder({ id, update: Number(active) === 4 ? {isPaid:1} : (Number(active) === 3 ? {isDelivered : 1, isPaid:0} : {isAccepted:Number(active), isPaid:0, isDelivered : 0 })});
  const onDelete =  id => {
    showAlerts({code:"warning", icon:"warning", title : "Delete order",msg : "Are you sure you want to delete this order ?  ", type : "confirm", action: {id}});
  }
  

  const configuratorOpen = (type, width,id) => { 
    setOpenConfigurator(dispatch,{ config : !openConfigurator, edit : type, width,id });
  }

  const Item = ({ id, image, name , date, seen , accepted }) => (
    <MDBox id={id} display="flex" alignItems="center" lineHeight={1}>
      <Badge badgeContent={seen || accepted ? 0 : "New" } sx={{'& .MuiBadge-anchorOriginTopRightRectangular':{fontSize:10, top:5, right : 5}}} color="error">
        <MDAvatar imgType="product" src={image} name={name} size="lg"  />
      </Badge>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{formatDistanceToNow(parseISO(date),{locale: frLocale})}</MDTypography>
      </MDBox>
    </MDBox>
  );

  if (isSuccess) {
    ordersRows =  orderList?.map( order => { 
      return ({
        order: <Item id={order.id} image={`${process.env.REACT_APP_PUBLIC_URL}/img/product/${order.orderItems[0].selectedImage}`} name={order.orderItems.slice(0, 3).map(item=>`${item.productName}x${item.quantity}`).join(', ')} date={order.createdAt} accepted={order.isAccepted} seen={order.isSeen} />,
        adress: (
          <MDBox ml={-1} sx={{textAlign : "left"}}>
            <MDTypography  variant="caption"  color="text">
            {order.shippingAddress.location.street}
            </MDTypography>
            <MDTypography  variant="body2" color="text" fontWeight="medium">
            <small>{order.shippingAddress.phone}</small>
            </MDTypography>
          </MDBox>
        ),
        totalPrice: (
          <MDBox ml={-1}>
            <MDTypography  variant="h6" color="text" fontWeight="medium">
            {order.totalPrice}
            </MDTypography>
            <MDTypography display="flex" alignSelf="start" variant="caption" color="primary" fontWeight="medium">
              {order.paymentMethod}
            </MDTypography>
          </MDBox>
        ),
        
        statut : ["Commandes-Clients","ventes"].includes(decodeURL) ? (
          <MDBox ml={-1}>
            <OptionsSelect
              options={["en cours","acceptée", "declinée","délivrée", "payée"]}
              selected={order.isPaid === 1 ? 4 : (order.isDelivered === 1 ? 3 : order.isAccepted)}
              id={order.id}
              label="status"
              onChange={handleAccepted}
              size="small"
              sx={{ml:1, maxWidth:100}}
          /></MDBox>):(
          <MDBox ml={-1}>
            <MDTypography  variant="span" color="text" >
              <MDBadge sx={{backGroundColor: ({functions:{rgba}, palette })=>rgba(palette[order.step.color].main, 0.3), "& .MuiBadge-badge" : {border:({palette})=>`1px solid ${palette[order.step.color].main}`}}} circular badgeContent={order.step.status}  variant="contained" size="sm" color={order.step.color} border />
            </MDTypography>  
          </MDBox>),
        action: (
          <MDTypography component="div" color="text" fontWeight="medium">     
            <Stack direction="row" alignItems="flex-end" spacing={1}>
              {["Commandes-Clients","ventes"].includes(decodeURL) && <IosSwitch checked={order.isPaid} action={handlePaid} txt={{active :'payée', deactive:"Non Payée"}} attribute={order.id} />}
              <Tooltip title="plus de détails" placement="top" arrow>
                <MDButton component={Link} to={`/profil/orderDetails/${order.id}`} size="medium" disableRipple={false}  sx={{minHeight:35, minWidth:35, p:.5}}  variant="gradient"  color="light"><Icon size="medium">info</Icon></MDButton>
              </Tooltip>
              <Tooltip title="Delete order" placement="top" arrow>
                <MDButton size="small" disableRipple sx={{minHeight:35, minWidth:35, p:.5}} onClick={()=>onDelete(order.id)} variant="gradient" color="error"><Icon size="medium">delete</Icon></MDButton>
              </Tooltip>
            </Stack>
          </MDTypography>
        ),
        id : order.id
      })}
    );
  }
  
  return {
    pageCount  :  pageCount,
    totalResult,
    changePage : getOrders,
    configuratorOpen,
    isLoading : isLoading || isFetching,
    columns: [
        { Header: "order", accessor: "order", width: "25%", align: "left" },
        { Header: "adress", accessor: "adress", align: "left" },
        { Header: "totalPrice", accessor: "totalPrice", align: "center" },
        { Header: "statut", accessor: "statut", align: "center" },
        { Header: "action", accessor: "action", align: "center" },
      ],

    rows: ordersRows,
  };
}
